import VueGtag, {trackRouter} from 'vue-gtag-next'

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig()
  const gtagId = {
    id: runtimeConfig.public.gtagId
  }

  nuxtApp.vueApp.use(
    VueGtag,
    {
      property: gtagId,
      appName: 'guardiannsHomepage'
    },
    trackRouter(useRouter())
  )
})
